export default __webpack_public_path__ + "static/media/apex-logo-dark.9c9131e8.svg";